export namespace GoogleMapsValidationModel {

  export enum ConfirmationLevel {
    CONFIRMATION_LEVEL_UNSPECIFIED,
    CONFIRMED,
    UNCONFIRMED_BUT_PLAUSIBLE,
    UNCONFIRMED_AND_SUSPICIOUS
  }

  export enum Granularity {
    GRANULARITY_UNSPECIFIED = 'GRANULARITY_UNSPECIFIED',
    PREMISE = 'PREMISE',
    SUB_PREMISE = 'SUB_PREMISE',
    PREMISE_PROXIMITY = 'PREMISE_PROXIMITY',
    BLOCK = 'BLOCK',
    ROUTE = 'ROUTE',
    OTHER = 'OTHER'
  }

  export class AddressComponent {
    componentName: {
      text: string,
      languageCode: string
    };
    componentType: string;
    confirmationLevel: ConfirmationLevel;
    inferred: boolean;
    spellCorrected: boolean;
    replaced: boolean;
    unexpected: boolean;
  }

  export class Location {
    latitude: number;
    longitude: number;
  }

  export class PostalAddress {
    revision?: number;
    regionCode: string;
    languageCode: string;
    postalCode?: string;
    sortingCode?: string;
    administrativeArea?: string;
    locality?: string;
    sublocality?: string;
    addressLines: string[];
    recipients?: string[];
    organization?: string;
  }


  export class PlusCode {
    globalCode: string;
    compoundCode: string;
  }

  export class Viewport {
    low: Location;
    high: Location;
  }

  export class AddressMetadata {
    business: boolean;
    poBox: boolean;
    residential: boolean;
  }

  export class UspsAddress {
    firstAddressLine: string;
    firm: string;
    secondAddressLine: string;
    urbanization: string;
    cityStateZipAddressLine: string;
    city: string;
    state: string;
    zipCode: string;
    zipCodeExtension: string;
  }

  export class UspsData {
    standardizedAddress: UspsAddress;
    postOfficeCity: string;
    postOfficeState: string;
    county: string;
    poBoxOnlyPostalCode: boolean;
    errorMessage: string;
    cassProcessed: boolean;
  }

  export class Geocode {
    location: Location;
    plusCode: PlusCode;
    bounds: Viewport;
    featureSizeMeters: number;
    placeId: string;
    placeTypes: string[];
  }

  export class Address {
    formattedAddress: string;
    postalAddress: PostalAddress;
    addressComponents: [AddressComponent];
    missingComponentTypes: string[];
    unconfirmedComponentTypes: string[];
    unresolvedTokens: string[];
  }

  export class Verdict {
    inputGranularity: Granularity;
    validationGranularity: Granularity;
    geocodeGranularity: Granularity;
    addressComplete: boolean;
    hasUnconfirmedComponents: boolean;
    hasInferredComponents: boolean;
    hasReplacedComponents: boolean;
  }

  export class Result {
    verdict: Verdict;
    address: Address;
    geocode: Geocode;
    metadata: AddressMetadata;
    uspsData: UspsData;
    englishLatinAddress: Address;
    public toString(): string {
      return JSON.stringify(this);
    }
  }

  export class ResponseBody {
    result: Result;
  }

  export class RequestBody {
    address: PostalAddress;
    previousResponseId: string;
    constructor(address: PostalAddress, previousResonseId: string = null) {
      this.address = address;
      this.previousResponseId = previousResonseId;
    }
  }



}



